module.exports = __webpack_public_path__ + "static/media/promoViddy.771c3393.mp4";